const NewsCardSkeleton = () => {
  return (
    <div className="relative block rounded-3xl overflow-hidden bg-muted">
      <div className="relative aspect-3/4 w-full skeleton-shimmer">
        {/* Overlay matching the real card's dark gradient */}
        <div className="absolute inset-0 bg-linear-to-t from-black/60 via-black/40 to-transparent" />

        {/* Content overlay matching NewsCard structure */}
        <div className="absolute inset-0 p-6 pb-8 flex flex-col justify-between">
          {/* Top - circular arrow placeholder */}
          <div className="flex items-start justify-end">
            <div className="w-12 h-12 rounded-full bg-white/15 border border-white/20" />
          </div>

          {/* Bottom - author logo, title, content, date */}
          <div className="space-y-2 pb-6">
            <div className="h-6 w-24 bg-white/15 rounded mb-3" />
            <div className="h-5 w-full bg-white/20 rounded" />
            <div className="h-5 w-4/5 bg-white/20 rounded" />
            <div className="h-4 w-full bg-white/10 rounded mt-3" />
            <div className="h-4 w-3/5 bg-white/10 rounded" />
            <div className="h-3 w-20 bg-white/10 rounded mt-3" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewsCardSkeleton;
